import { cn } from '@listening/utils/react-helpers';
import ChevronLeft from '@listening/assets/icons/chevronLeft.svg?react';
import StarIcon from '@listening/assets/icons/star.svg?react';
import annaVPng from '@listening/assets/imgs/anna-v.png';
import * as m from '@/paraglide/messages';

import jayatiPng from '@listening/assets/imgs/Jayati-S.png';

import { Button } from '@listening/frontend/components/radix/button';
import {
  Carousel,
  type CarouselApi,
  useCarouselStep,
  CarouselContent,
  CarouselItem,
} from '@listening/frontend/components/radix/carousel';
import Autoplay from 'embla-carousel-autoplay';
import { useState } from 'react';

const slides = [
  {
    name: () => m.marketing_app_anna_name(),
    profession: () => m.marketing_app_anna_profession(),
    Img: () => (
      <img
        alt={m.marketing_app_anna_name()}
        className='relative size-8 rounded-full object-cover object-[0px_-3px]'
        src={annaVPng}
      />
    ),
    Slide: () => (
      <CarouselItem>
        <div className='self-stretch text-center'>
          <span className='text-sm leading-[25.20px] font-normal text-steel-700 dark:text-steel-260'>
            {m.marketing_app_anna_quote_p1()}
          </span>
          <span className='text-lg leading-loose font-medium text-steel-900 dark:text-steel-260'>
            {m.marketing_app_anna_quote_bold()}
          </span>
          <span className='text-sm leading-[25.20px] font-normal text-steel-700 dark:text-steel-260'>
            {m.marketing_app_anna_quote_p2()}
          </span>
        </div>
      </CarouselItem>
    ),
  },
  {
    name: () => m.marketing_app_jayati_name(),
    profession: () => '',
    Img: () => (
      <img
        alt={m.marketing_app_jayati_name()}
        className='relative size-8 rounded-full object-cover object-[0px_-3px]'
        src={jayatiPng}
      />
    ),
    Slide: () => (
      <CarouselItem>
        <div className='self-stretch text-center'>
          <span className='text-sm leading-[25.20px] font-normal text-steel-700 dark:text-steel-260'>
            {m.marketing_app_jayati_quote_p1()}
          </span>
          <span className='text-lg leading-loose font-medium text-steel-900 dark:text-steel-260'>
            {m.marketing_app_jayati_quote_bold()}
          </span>
          <span className='text-sm leading-[25.20px] font-normal text-steel-700 dark:text-steel-260'>
            {m.marketing_app_jayati_quote_p2()}
          </span>
        </div>
      </CarouselItem>
    ),
  },
];
export function CustomerTestimonial() {
  const [api, setApi] = useState<CarouselApi>();
  const { current: currentStep } = useCarouselStep(api);
  const current = Math.max(currentStep - 1, 0);

  const currentSlide = slides[current];
  if (!currentSlide) throw new Error('No slide');

  const Img = currentSlide.Img;
  return (
    <Carousel
      className='z-10 flex flex-col items-center justify-center gap-4 rounded-3xl bg-white px-8 py-6 dark:bg-muted'
      opts={{
        loop: true,
      }}
      plugins={[
        Autoplay({
          delay: 4 * 1000,
        }),
      ]}
      setApi={setApi}
    >
      <div className='flex items-start justify-start'>
        <StarIcon className='size-6' />
        <StarIcon className='size-6' />
        <StarIcon className='size-6' />
        <StarIcon className='size-6' />
        <StarIcon className='size-6' />
      </div>

      <CarouselContent>
        {slides.map(({ Slide }, idx) => (
          <Slide key={`slide_${idx.toString()}`} />
        ))}
      </CarouselContent>
      <div className='flex items-center justify-center self-stretch'>
        <Button
          className='flex h-auto origin-top-left items-center justify-start rounded-full border border-steel-700/10 p-2'
          onClick={() => api?.scrollPrev()}
          variant='ghost'
        >
          <ChevronLeft className='size-2 text-steel-700 dark:text-steel-260' />
        </Button>
        <div className='flex flex-col items-center justify-center gap-1 px-6'>
          <Img />
          <div className='flex flex-col items-center justify-center gap-0.5'>
            <div className='text-sm leading-[18.90px] font-semibold text-navy-800 dark:text-white'>
              {currentSlide.name()}
            </div>
            <div className='text-xs leading-none font-normal text-steel-700 dark:text-steel-260'>
              {currentSlide.profession()}
            </div>
          </div>
        </div>
        <Button
          className='flex h-auto rotate-180 items-center justify-start rounded-full border border-steel-700/10 p-2'
          onClick={() => api?.scrollNext()}
          variant='ghost'
        >
          <ChevronLeft className='size-2 text-steel-700 dark:text-steel-260' />
        </Button>
      </div>
      <div className='flex items-center justify-start gap-1'>
        {slides.map((_, idx) => (
          <div
            className={cn(
              'size-2 rounded-full',
              current === idx ? 'bg-steel-340' : 'bg-neutral-245',
            )}
            key={`indicator_${idx.toString()}`}
          />
        ))}
      </div>
    </Carousel>
  );
}
